import SimulationsCopilotPage from '@/components/SimulationsCopilotPage';
import type { Route } from './+types/home';

export function meta({}: Route.MetaArgs) {
  return [
    { title: 'From Scenario to Simulation in Seconds' },
    {
      name: 'description',
      content:
        'Access our extensive library of professional quality simulations, with Simulations Copilot to help you find exactly what you need.',
    },
  ];
}

export default function Home() {
  return <SimulationsCopilotPage />;
}
